import { ReactElement, useState } from "react";
import {
  PageWrapper,
  Header,
  SectionContainer,
  RowWrapper,
  ColumnWrapper,
  PrimaryButton,
} from "../../components";
import {
  CardWrapper,
  CarouselImage,
  FirstSectionWrappper,
  SecondSectionWrapper,
  ServiceContainerWrapper,
  ServiceMainContainerWrapper,
  ServiceContentContainerWrapper,
  ThirdSectionWrapper,
  CateringImage,
  ServiceContent2ContainerWrapper,
  ServiceTextContainer,
} from "./subComponents";
import { Subtitles, Title, TitleWrapper } from "../../typography";
import seperator_img from "../../assests/separator.png";
import { colors, fontfamily } from "../../const/theme";
import { SectionCardWrapper } from "./helper";
import Footer from "../Footer";
import { useNavigate } from "react-router";
import MENUS_TYPE from "../../const/menus";
import breakfast from "../../assests/section_2/breakfast.jpg";
import desets from "../../assests/section_2/deserts.jpg";
import drinks from "../../assests/section_2/drinks.jpg";
import maincourses from "../../assests/section_2/main-course.jpg";
import snacks from "../../assests/section_2/snacks.jpg";
import about from "../../assests/section_3/food-cutlery.jpg";
import Catering from "../../assests/catering.jpg";
import Lease from "../../assests/lease.jpg";
const Home = (): ReactElement => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [position, setPosition] = useState(0);
  const onScroll = (event: any) => {
    const scrollPosition = event.target.scrollingElement.scrollTop;
    setPosition(scrollPosition);
  };
  document.addEventListener("scroll", onScroll);

  const navigate = useNavigate();

  return (
    <PageWrapper>
      <Header
      // position={position >= 500 ? "fixed" : "absolute"}
      // height={position >= 500 ? "90px" : "100px"}
      // background={position >= 500 ? "#000324" : "transparent"}
      // scrollPosition={position >= 500}
      />
      <FirstSectionWrappper indicators={false} controls={true} fade={true}>
        <CarouselImage interval={2000}>
          <TitleWrapper margin="90px 0 0 0 ">
            <Subtitles
              font="12px"
              fontFamily={fontfamily.fontFamilyDMS}
              letterSpacing="4px"
              fontWeight={700}
              color={colors.primary}
            >
              AMAZING & DELICIOUS
            </Subtitles>
            <img
              src={seperator_img}
              alt=""
              height={13}
              width={100}
              className="mt-2"
            />
            <Title
              font="80px"
              fontFamily={fontfamily.fontFamilyForum}
              lineHeight="80px"
              fontWeight={400}
              color={colors?.white}
              className="mt-2"
            >
              For the love of <br />
              delicious food
            </Title>{" "}
            <Subtitles
              font="20px"
              fontFamily={fontfamily.fontFamilyDMS}
              lineHeight="80px"
              fontWeight={400}
              color={colors?.white}
            >
              Come with family & feel the joy of mouthwatering food
            </Subtitles>
          </TitleWrapper>
        </CarouselImage>
        <CarouselImage interval={2000}>
          <TitleWrapper margin="90px 0 0 0 ">
            <Subtitles
              font="12px"
              fontFamily={fontfamily.fontFamilyDMS}
              letterSpacing="4px"
              fontWeight={700}
              color={colors?.primary}
            >
              TRADATIONAL & HYGINE
            </Subtitles>
            <img
              src={seperator_img}
              alt=""
              height={13}
              width={100}
              className="mt-2"
            />
            <Title
              font="80px"
              fontFamily={fontfamily.fontFamilyForum}
              lineHeight="80px"
              fontWeight={400}
              color={colors?.white}
              className="mt-2"
            >
              Where every meal <br />
              is an adventure.
            </Title>
            <Subtitles
              font="20px"
              fontFamily={fontfamily.fontFamilyDMS}
              lineHeight="80px"
              fontWeight={400}
              color={colors?.white}
            >
              Come with family & feel the joy of mouthwatering food
            </Subtitles>
          </TitleWrapper>
        </CarouselImage>{" "}
        <CarouselImage interval={2000}>
          <TitleWrapper margin="90px 0 0 0 ">
            <Subtitles
              font="12px"
              fontFamily={fontfamily.fontFamilyDMS}
              letterSpacing="4px"
              fontWeight={700}
              color={colors?.primary}
            >
              DELIGHTFUL EXPERIENCE
            </Subtitles>
            <img
              src={seperator_img}
              alt=""
              height={13}
              width={100}
              className="mt-2"
            />
            <Title
              font="80px"
              fontFamily={fontfamily.fontFamilyForum}
              lineHeight="80px"
              fontWeight={400}
              color={colors?.white}
              className="mt-2"
            >
              Crafted with passion, <br />
              served with love.
            </Title>
            <Subtitles
              font="20px"
              fontFamily={fontfamily.fontFamilyDMS}
              lineHeight="80px"
              fontWeight={400}
              color={colors?.white}
            >
              Come with family & feel the joy of mouthwatering food
            </Subtitles>
          </TitleWrapper>
        </CarouselImage>
      </FirstSectionWrappper>
      <ServiceContainerWrapper>
        <ServiceMainContainerWrapper>
          <TitleWrapper>
            <Subtitles
              font="12px"
              fontFamily={fontfamily.fontFamilyDMS}
              letterSpacing="4px"
              fontWeight={700}
              color={colors?.primary}
            >
              OUR SERVICES
            </Subtitles>{" "}
            <img
              src={seperator_img}
              alt=""
              height={13}
              width={100}
              className="mt-2"
            />
          </TitleWrapper>
        </ServiceMainContainerWrapper>
        <ServiceMainContainerWrapper>
          <ServiceContentContainerWrapper order>
            <Title
              font="60px"
              fontFamily={fontfamily.fontFamilyForum}
              lineHeight="1.20em"
              fontWeight={400}
              color={colors?.white}
              className="mt-4"
            >
              Catering
            </Title>
            <ServiceTextContainer>
              <Subtitles
                font="16px"
                fontFamily={fontfamily.fontFamilyDMS}
                lineHeight="30px"
                fontWeight={400}
                textAlign="center"
                color={colors?.white}
                className="mt-2"
              >
                We welcome caterers, food vendors, bakers, confectioners, food
                trucks, farmers, food processors, and personal chefs to share
                our space to create their specialty products as well as support
                each other in a productive networking environment.
              </Subtitles>
            </ServiceTextContainer>
          </ServiceContentContainerWrapper>
          <ServiceContent2ContainerWrapper order>
            <CateringImage src={Catering} alt="image" />
          </ServiceContent2ContainerWrapper>
        </ServiceMainContainerWrapper>
        <ServiceMainContainerWrapper>
          <ServiceContentContainerWrapper>
            <CateringImage src={Lease} alt="image" />
          </ServiceContentContainerWrapper>
          <ServiceContent2ContainerWrapper>
            <Title
              font="60px"
              fontFamily={fontfamily.fontFamilyForum}
              lineHeight="1.20em"
              fontWeight={400}
              color={colors?.white}
              className="mt-4"
            >
              Kitchen contract
            </Title>
            <ServiceTextContainer>
              <Subtitles
                font="16px"
                fontFamily={fontfamily.fontFamilyDMS}
                lineHeight="30px"
                fontWeight={400}
                textAlign="center"
                color={colors?.white}
                className="mt-2"
              >
                Namma kitchen provides the infrastructure and support needed by
                an entrepreneur during their start-up phase and when they want
                to expand, allowing the opportunity to start from scratch and
                grow at their own pace. By using our kitchen a business owner
                will eliminate the need to purchase expensive equipment, sign a
                long-term lease, take on debt for remodeling, or many other
                risks that are expected when starting a business.
              </Subtitles>
            </ServiceTextContainer>
          </ServiceContent2ContainerWrapper>
        </ServiceMainContainerWrapper>
      </ServiceContainerWrapper>
      <SecondSectionWrapper>
        <SectionContainer>
          <TitleWrapper>
            <Subtitles
              font="12px"
              fontFamily={fontfamily.fontFamilyDMS}
              letterSpacing="4px"
              fontWeight={700}
              color={colors?.primary}
            >
              FLAVOR FOR ROYALTY
            </Subtitles>{" "}
            <img
              src={seperator_img}
              alt=""
              height={13}
              width={100}
              className="mt-2"
            />
            <Title
              font="60px"
              fontFamily={fontfamily.fontFamilyForum}
              lineHeight="1.20em"
              fontWeight={400}
              color={colors?.white}
              className="mt-4"
            >
              We Offer Top Notch
            </Title>
          </TitleWrapper>
          <CardWrapper>
            <SectionCardWrapper
              title="Breakfast"
              image={breakfast}
              onClick={() => {
                navigate("/menu-lists", {
                  state: { menu_name: MENUS_TYPE.breakFast },
                });
              }}
            />
            <div
              style={{
                width: "370px",
                position: "absolute",
                top: "400px",
                left: "0",
                right: "0",
                bottom: "0",
                margin: "auto",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                textAlign: "center",
                alignItems: "center",
              }}
            >
              <p className="para w-75">
                Welcome to Delicious Bites, where every dish is a journey of
                flavors! Our chefs craft each meal with passion, using the
                freshest ingredients to create unforgettable dining experiences.
                Whether you're craving savory or sweet, our menu offers a
                delightful range for every palate. Come enjoy a cozy atmosphere,
                perfect for family gatherings or intimate dinners.
              </p>
              <SectionCardWrapper
                image={maincourses}
                title="Main Courses"
                onClick={() => {
                  navigate("/menu-lists", {
                    state: { menu_name: MENUS_TYPE.mainCourse },
                  });
                }}
              />
            </div>
            <SectionCardWrapper
              image={snacks}
              title="Snacks/Appetizer"
              onClick={() => {
                navigate("/menu-lists", {
                  state: { menu_name: MENUS_TYPE.snacks },
                });
              }}
            />
          </CardWrapper>
          <CardWrapper style={{ marginTop: "70px" }}>
            <SectionCardWrapper
              title="Desserts"
              image={desets}
              onClick={() => {
                navigate("/menu-lists", {
                  state: { menu_name: MENUS_TYPE.desserst },
                });
              }}
            />
            <SectionCardWrapper
              title="Drinks"
              image={drinks}
              onClick={() => {
                navigate("/menu-lists", {
                  state: { menu_name: MENUS_TYPE.drinks },
                });
              }}
            />{" "}
            {/* <div style={{ width: "370px" }}></div> */}
          </CardWrapper>
        </SectionContainer>
      </SecondSectionWrapper>
      <ThirdSectionWrapper>
        <SectionContainer>
          <RowWrapper>
            <ColumnWrapper>
              <TitleWrapper>
                <Subtitles
                  font="12px"
                  fontFamily={fontfamily.fontFamilyDMS}
                  letterSpacing="4px"
                  fontWeight={700}
                  color={colors?.primary}
                >
                  OUR STORY
                </Subtitles>{" "}
                <img
                  src={seperator_img}
                  alt=""
                  height={13}
                  width={100}
                  className="mt-2"
                />
                <Title
                  font="60px"
                  fontFamily={fontfamily.fontFamilyForum}
                  lineHeight="1.20em"
                  fontWeight={400}
                  color={colors?.white}
                  className="mt-4"
                >
                  Every Flavor <br /> Tells a Story
                </Title>
                <Subtitles
                  font="16px"
                  fontFamily={fontfamily.fontFamilyDMS}
                  lineHeight="30px"
                  fontWeight={400}
                  textAlign="center"
                  color={colors?.white}
                  className="mt-2 w-50"
                >
                  Namma kitchen Catering is a South Indian catering Service that
                  specializes in providing delicious and authentic South Indian
                  cuisine for various events and occasions. With a strong
                  emphasis on quality and taste, Namma kitchen aims to bring the
                  flavors of South India to your home events.
                </Subtitles>
                <PrimaryButton text="Read More" onClick={() => {}} />
              </TitleWrapper>
            </ColumnWrapper>
            <ColumnWrapper>
              <img src={about} alt="" style={{ borderRadius: "5px" }} />
            </ColumnWrapper>
          </RowWrapper>
        </SectionContainer>
      </ThirdSectionWrapper>
      <Footer />
    </PageWrapper>
  );
};

export default Home;
